export const DuplicateQuotationIcon = ({ className = "" }: { className?: string }) => {
	return (
		<svg
			className={className}
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8912 1.55067V3.96121C10.8904 5.1377 11.8431 6.09202 13.0196 6.09527H15.302M11.7207 2.02542C11.3988 1.68975 10.9537 1.50002 10.4882 1.50002H5.77908C4.07882 1.49353 2.68585 2.8484 2.64531 4.54786V13.3037C2.6072 15.0308 3.97666 16.4611 5.70368 16.4992C5.72882 16.5 12.3086 16.5 12.3086 16.5C14.0202 16.4302 15.3685 15.0162 15.3564 13.3037V6.49947C15.3564 6.05839 15.1853 5.63434 14.8804 5.3165L11.7207 2.02542Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.59333 8.02344H7.5955C7.00115 8.02344 6.51953 8.5051 6.51953 9.09944C6.51953 9.69369 7.00115 10.1754 7.5955 10.1754H8.82466C9.419 10.1754 9.90058 10.6569 9.90058 11.2513C9.90058 11.8456 9.419 12.3273 8.82466 12.3273H6.82682"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.21094 12.3297V13.2329M8.21094 7.11719V8.02852"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
